@if (imageUrl() && !failed()) {
  <img
    class="avatar__img"
    [src]="imageUrl()"
    [style.width.px]="size()"
    [style.height.px]="size()"
    (error)="onError()"
    alt=""
  />
} @else {
  <div
    class="avatar__initials"
    [style.width.px]="size()"
    [style.height.px]="size()"
  >
    {{ initials() }}
  </div>
}
